import React from 'react';

const InstructorCalendarSkeleton: React.FC = () => {
  return (
    <tbody>
      {[...Array(20)].map((_, i) => (
        <tr key={i} className='border-t hover:bg-gray-50'>
          {/* Sticky Left Date Column */}
          <td className='border p-3 whitespace-nowrap bg-white sticky left-0 z-10 font-medium border-r'>
            <div className='h-4 w-24 bg-slate-100 rounded-full animate-pulse' />
          </td>
          {/* Time Slot Columns */}
          {[...Array(30)].map((_, j) => (
            <td
              key={j}
              className='border px-2 py-3 whitespace-nowrap min-w-[45px]'
            >
              <div className='h-4 w-full bg-slate-100 rounded-full animate-pulse mx-auto' />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default InstructorCalendarSkeleton;
